import { Button, Dialog, DialogActions, DialogContent, Divider, Link, Typography } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack } from '@mui/system';
import { useState } from 'react';
import AcknowledgmentDialog from './AcknowledgementDialog.tsx';
import { Trans } from 'react-i18next';

interface AboutDialogProps {
  open: boolean;
  onClose: () => void;
}

const AboutDialog = ({ open, onClose }: AboutDialogProps) => {
  const [ackDialogOpen, setAckDialogOpen] = useState(false);

  const handleAcknowledgmentClick = () => {
    setAckDialogOpen(true);
  };

  const handleAckDialogClose = () => {
    setAckDialogOpen(false);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle align="center">
        <Trans i18nKey="aboutDialog.about.title">About</Trans>
      </DialogTitle>
      <Divider />
      <DialogContent style={{ padding: '3rem 2.75rem' }}>
        <Stack direction="column" spacing={2} useFlexGap flexWrap="wrap" style={{ alignItems: 'flex-start' }}>
          <Link href="https://edu.sphero.com/child-policy" target="_blank" rel="noopener noreferrer">
            <Typography>
              <Trans i18nKey="menu.bps-privacy-policy">BPS Privacy Policy</Trans>
            </Typography>
          </Link>
          <Link href="https://sphero.com/pages/privacy" target="_blank" rel="noopener noreferrer">
            <Typography>
              <Trans i18nKey="menu.general-privacy-policy">General Privacy Policy</Trans>
            </Typography>
          </Link>
          <Link href="https://sphero.com/pages/terms-of-use" target="_blank" rel="noopener noreferrer">
            <Typography>
              <Trans i18nKey="menu.terms-of-use">Terms of Use</Trans>
            </Typography>
          </Link>
          <Link component="button" onClick={handleAcknowledgmentClick}>
            <Typography>
              <Trans i18nKey="aboutDialog.menu.acknowledgments">Acknowledgments</Trans>
            </Typography>
          </Link>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions style={{ margin: '2px 12px' }}>
        <Button variant="contained" autoFocus onClick={onClose}>
          <Trans i18nKey="aboutDialog.button.close">Close</Trans>
        </Button>
      </DialogActions>

      <AcknowledgmentDialog open={ackDialogOpen} onClose={handleAckDialogClose} />
    </Dialog>
  );
};

export default AboutDialog;
